export const DELETED_STATE = 'deleted';
export const DELETED_COMMENT_PLACEHOLDER = '[removed by author]';
